export default "__VITE_ASSET__Bo$4ZC5K__"